import React, { useState, useEffect } from "react";
import CloseIcon from '@mui/icons-material/CloseRounded';
import { Button, Modal, CardGroup, Card } from "react-bootstrap";
import _ from "lodash";
import { useLocation } from "react-router-dom";
import ApiBasketLog from "../../../../../core/api/api.basketLog";

export const BasketLogModal = ({ show2, size }) => {
  let location = useLocation();
  const [show, setShow] = useState(show2);
  const handleClose = () => setShow(false);
  const [logList, setlogList] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        if (location != null && !_.isEmpty(location.state) && !_.isEmpty(location.state.data?.basketId)) {
          // دریافت اطلاعات تاریخچه این سبد خرید
          let response = await ApiBasketLog.getBasketLog({ basketId: location.state.data?.basketId, pageSize: 100 });
          if (response.succeeded == true) {
            setlogList(response.data);
          }
        }
      } catch (error) {
      }
    })();
    return () => { };
  }, []);

  return (
    <div>
      {/* Start Modal */}
      <Modal centered size={size} show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title> تاریخچه تغییرات </Modal.Title>
        </Modal.Header>
        <Modal.Body >
          <CardGroup  >
            <Card>
              <Card.Text>
                عنوان
              </Card.Text>
            </Card>
            <Card>
              <Card.Text>
                توضیحات
              </Card.Text>
            </Card>
            <Card>
              <Card.Text>
                مقدار
              </Card.Text>
            </Card>
            <Card>
              <Card.Text>
                کاربر
              </Card.Text>
            </Card>
            <Card>
              <Card.Text>
                تاریخ
              </Card.Text>
            </Card>
          </CardGroup>
          {logList !== null && logList?.map((item, Index) =>
            <CardGroup key={Index} >
              <Card>
                <Card.Text>
                  {item.logTypeS}
                </Card.Text>
              </Card>
              <Card>
                <Card.Text>
                  {item.description}
                </Card.Text>
              </Card>
              <Card>
                <Card.Text>
                  {item.value}
                </Card.Text>
              </Card>
              <Card>
                <Card.Text>
                  {item.createdByFullName}
                </Card.Text>
              </Card>
              <Card>
                <Card.Text>
                  {item.created}
                </Card.Text>
              </Card>
            </CardGroup>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={handleClose}>
            <CloseIcon />  بستن
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
